var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElementPlus = function SvgElementPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M10.584 0H3.156A2.656 2.656 0 0 0 .5 2.656v7.43a2.656 2.656 0 0 0 2.656 2.656h7.428a2.656 2.656 0 0 0 2.655-2.657V2.656A2.656 2.656 0 0 0 10.584 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M27.843 0h-7.427a2.656 2.656 0 0 0-2.656 2.656v7.43a2.656 2.656 0 0 0 2.656 2.656h7.427a2.656 2.656 0 0 0 2.656-2.657V2.656A2.656 2.656 0 0 0 27.843 0M10.584 17.258H3.156A2.656 2.656 0 0 0 .5 19.915v7.429A2.656 2.656 0 0 0 3.156 30h7.428a2.656 2.656 0 0 0 2.655-2.656v-7.43a2.656 2.656 0 0 0-2.655-2.656",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M28.799 24.764h-9.334a1.125 1.125 0 0 1 0-2.251H28.8a1.126 1.126 0 0 1 0 2.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M24.134 29.43a1.125 1.125 0 0 1-1.125-1.126v-9.335a1.126 1.126 0 0 1 2.25 0v9.335a1.126 1.126 0 0 1-1.125 1.125"
  })));
};
export default SvgElementPlus;